import CrudManager from '@/components/admin/CrudManager';

/**
 * LEGACY flat gallery. New content should be created in "Gallery Albums" instead.
 * Kept for backwards compatibility with the homepage gallery strip and older items.
 */

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'caption', label: 'Caption', type: 'text' },
    {
        key: 'type',
        label: 'Type',
        type: 'select',
        options: [
            { value: 'photo', label: 'Photo' },
            { value: 'video', label: 'Video (YouTube/Vimeo embed URL)' },
        ],
    },
    // Photo upload — writes the CDN url into `url`
    {
        key: 'url',
        label: 'Photo upload (for Type = Photo)',
        type: 'upload-image',
        prefix: 'gallery',
        hint: 'For Type = Photo: upload the image here. For Type = Video: leave blank and paste the embed URL in the field below.',
    },
    // Video embed URL — plain text input, ALSO writes to `url` on save (merge below)
    {
        key: 'video_embed_url',
        label: 'Video embed URL (for Type = Video)',
        type: 'text',
        placeholder: 'https://www.youtube.com/embed/VIDEO_ID or https://player.vimeo.com/video/VIDEO_ID',
        hint: 'YouTube / Vimeo embed URL. This will be saved as the media URL when Type = Video.',
    },
    {
        key: 'thumbnail_url',
        label: 'Thumbnail (used for videos)',
        type: 'upload-image',
        prefix: 'gallery/thumbs',
    },
    { key: 'category', label: 'Category', type: 'text' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'type', label: 'Type' },
    { key: 'category', label: 'Category' },
];

const defaultItem = {
    title: '',
    caption: '',
    type: 'photo',
    url: '',
    video_embed_url: '',
    thumbnail_url: '',
    category: 'General',
    order: 99,
};

// When editing an existing item, seed video_embed_url from url if type === 'video'
const beforeEdit = (item) => {
    if (item?.type === 'video' && item?.url && !item.video_embed_url) {
        return { ...item, video_embed_url: item.url };
    }
    return item;
};

// Before save: if type === 'video' and video_embed_url has value, use it as url.
const beforeSave = (payload) => {
    const next = { ...payload };
    if (next.type === 'video' && next.video_embed_url) {
        next.url = next.video_embed_url;
    }
    // Remove the helper key so it doesn't get stored in DB
    delete next.video_embed_url;
    return next;
};

export default function AdminGalleryPage() {
    return (
        <CrudManager
            resource="gallery"
            title="Gallery (Legacy)"
            description="Flat photo/video items shown on the homepage strip. For the main Gallery page, use the new 'Gallery Albums' section instead."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'category']}
            beforeEdit={beforeEdit}
            beforeSave={beforeSave}
        />
    );
}
